import { Injectable, inject } from '@angular/core';
import { ToastController, Platform, LoadingController, AlertController, ModalController, PopoverController, AlertButton } from '@ionic/angular/standalone';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';

@Injectable({
  providedIn: 'any'
})
export class LlamadasAlertsService {
  platform = inject(Platform);
  private toastController = inject(ToastController);
  private loadingCtrl = inject(LoadingController);
  private alertController = inject(AlertController);
  diagnostics = inject(Diagnostic);
  private modalController = inject(ModalController);
  private popoverController = inject(PopoverController);

  loadingObject: any;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  async presentLoading(mensaje?: string) {

    if (this.loadingObject == null) {

      if (mensaje != null) {

        this.loadingObject = await this.loadingCtrl.create({

          message: mensaje

        })

        await this.loadingObject.present();



      } else {

        this.loadingObject = await this.loadingCtrl.create()

        await this.loadingObject.present();

      }

    }

  }

  async presentAlertVersion(respuesta) {

    const alert = await this.alertController.create({
      header: 'Actualización disponible',
      message: 'Hay una nueva versión de la app en su store, le recomendamos actualizarla',
      buttons: [
        {
          text: 'Ahora no',
          role: 'cancel',
          cssClass: 'secondary',
          htmlAttributes: {
            'backgroung-color': 'warning',
          },
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Actualizar',
          handler: () => {
            console.group('Handler Actualizar version app')
            if (this.platform.is('ios')) {
              // this.market.open('id1465943052')
              //   .then(valor => { console.log("esto es asín", valor) });
            }
            if (this.platform.is('android')) window.open('https://play.google.com/store/apps/details?id=es.amsystem.ampresencia.beta.portalempleado.app', "_system");
            if (this.platform.is('desktop')) window.open('https://play.google.com/store/apps/details?id=es.amsystem.ampresencia.beta.portalempleado.app', "_system");

            console.log("version incorrecta = Detslle  ", respuesta.Detalle);
            console.log("version incorrecta = Datos    ", respuesta.Datos);
            console.log("version incorrecta = Mensaje  ", respuesta.Mensaje);
            console.log("version incorrecta = Ok       ", respuesta.Ok);
            console.groupEnd();
          }
        }
      ]
    });

    await alert.present();
  }

  async presentToast(texto: string, color?: string, tiempo?: number, position?: "top" | "bottom" | "middle") {
    if (color == null) { color = 'success' };
    if (tiempo == null) { tiempo = 2000 };
    const toast = await this.toastController.create({
      position: position,
      message: texto,
      duration: tiempo,
      color: color
    });
    toast.present();

  }

  async presentAlert(hearder: string, subhearder: string, message?: string, buttons?: AlertButton[]) {
    if (buttons == null) buttons = [{ text: "De acuerdo", role:'cancel' }];
    const alert = await this.alertController.create({
      header: hearder,
      subHeader: subhearder,
      message: message,
      buttons: buttons
    });

    await alert.present();
  }

  async dissmisLoading() {

    if (this.loadingObject) {

      this.loadingCtrl.dismiss()

      this.loadingObject = null;

    };



  }


  async presentAlertGPS() {
    let alert = await this.alertController.create({
      header: 'GPS desactivado',
      message: 'Esta aplicación necesita que tengas el GPS activado, por favor activalo',
      buttons: [{
        text: 'Ir a ajustes',
        handler: (blah) => {
          this.diagnostics.switchToLocationSettings();
        }
      }, {
        text: 'Aceptar'
      }]
    });
    await alert.present();
  }
}
